export const data =
{
    teksti: ' Tämä on peli, jossa heitetään noppaa. Eli heitä noppaa.',
    optiot: []
};



